import { render } from "./NewsSummary.vue?vue&type=template&id=521e2e64&scoped=true&ts=true"
import script from "./NewsSummary.vue?vue&type=script&lang=ts"
export * from "./NewsSummary.vue?vue&type=script&lang=ts"

import "./NewsSummary.vue?vue&type=style&index=0&id=521e2e64&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-521e2e64"]])

export default __exports__